import axios from 'axios';
import * as types from '../actionTypes';
import * as config from '../../Config/api.js';
import moment from "moment";
import jwtDecode from 'jwt-decode';
import { setSearchLocation } from './Order.js';
	
export const setGlobalInnerLoading  = (status) => { 
	return { 
		type: types.GLOBAL_LOADING,
		payload: status 
	}
};

export const setGlobalInnerMessage  = (message) => { 
	return { 
		type: types.GLOBAL_MESSAGE,
		payload: message 
	}
};

export const setDialog  = (target,status) => { 
	return { 
		type: types.SET_DIALOG,
		payload: {target:target,status:status} 
	}
};

export const setLoginStatus  = (status) => { 
	return { 
		type: types.SET_LOGINSTATUS,
		payload: status
	}
};

export const setUserProfile  = (profile) => {
	return { 
		type: types.SET_USERPROFILE,
		payload: profile
	}
};	


export const setCurrentPartner  = (partner) => {
	return { 
		type: types.SET_CURRENTPARTNER,
		payload: partner
	}
};	

export const setCurrentCustomer  = (customer) => {
	return { 
		type: types.SET_CURRENTCUSTOMER,
		payload: customer
	}
};	


// convert input to desired output JSON	
function converterChaves(jsonEntrada) {
  const jsonSaida = jsonEntrada.map(obj => {
    return {
      code: obj.id,
      name: obj.nome
    };
  });

  return jsonSaida;
}


export const retrieveAppCities  = (id,props) => { 
		
		return dispatch => {
					
					var value = id;
	
					// Connect to retrieve content endpoint
					axios({
						   url    : 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/'+value+'/municipios',
						   method : 'GET',
						   headers: {
							Accept: 'application/json'
						}
					})				
					
					.then((response) => {

						//console.log("[response]--->"+JSON.stringify(response,null,2));

						// Harded CODE for TERMS...
						props.setDropdownCityItems(converterChaves(response.data));
						props.setCityResult(true);
						props.setCityLoading(false);						
						return;
						
					})
					.catch(error=> {
						console.log("[alertMessage]--->"+JSON.stringify("Ocorreu um erro geral ao se comunicar com a API. Verifique sua conexão e tente novamente.",null,2));
						return;
					});
					
	} // end dispatch

};


export const retrieveAppAddressGooglePlaces = (data, props) => {
	return dispatch => {
	  var preparedData = {
		search: data.keyword
	  };
  
	  axios({
		url: config.API_URL + '/retrieveGoogleAddress',
		method: 'POST',
		data: preparedData,
		headers: { Accept: 'application/json' }
	  })
	  .then((response) => {
		if (response.data.success) {
		  var returnArray = [];
		  var predictions = response.data.data; // 🔥 AQUI corrigido: é data, não data.predictions
  
		  for (var i = 0; i < predictions.length; i++) {
			let obj = {
			  index: i,
			  description: predictions[i].description,
			  place_id: predictions[i].place_id || null,
			  reference: predictions[i].reference || null,
			  structured_formatting: predictions[i].structured_formatting?.main_text || null,
			  terms: predictions[i].terms,
			  types: predictions[i].types
			};
			returnArray.push(obj);
		  }
  
		  props.setItems(returnArray);
		} else {
		  if (props.setError) {
			props.setError(response.data.message);
		  }
		}
	  })
	  .catch((error) => {
		console.error('Erro na consulta Google Places:', error);
		if (props.setError) {
		  props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
		}
	  });
	};
  };
  
  export const retrieveAppAddressGoogleCoordinates = (data, props) => {
	return dispatch => {
	  const preparedData = {
		address: data.address
	  };
  
	  axios({
		url: config.API_URL + '/retrieveGoogleCoordinates',
		method: 'POST',
		data: preparedData,
		headers: {
		  Accept: 'application/json',
		}
	  })
	  .then(response => {
		console.log('[RESPONSE GEOCOORDINATES] -> ', response.data);
  
		if (response.data.success && response.data.data) {
		  props.onSuccess(response.data.data); // callback de sucesso
		} else {
		  props.onError('Não foi possível encontrar as coordenadas.');
		}
	  })
	  .catch(error => {
		console.error('[ERROR GEOCOORDINATES] -> ', error);
		props.onError('Erro ao buscar coordenadas.');
	  });
	};
  };
  

export const retrieveAppAddressesGoogleMatrixDistance  = (data,props) => { 
		
		return dispatch => {
					
					var preparedData = {
						from:data.from,
						to:data.to,
					}
					// Connect to retrieve content endpoint
					axios({
						   url    : config.API_URL+'/order/transfer/retrieveAddressesDistance',
						   method : 'POST',
						   data   : preparedData,						   
						   headers: {
							Accept: 'application/json',
						}
					})				
					
					.then((response) => {

						//console.log("[response GOOGLnE MATRIX DISTANCE DATA]--->"+JSON.stringify(response.data.data,null,2));
						
						var distanceText = response.data.data.rows[0].elements[0].distance.text;
						var distanceValue = response.data.data.rows[0].elements[0].distance.value;
						
						console.log("[response GOOGLE MATRIX DISTANCE DATA Distancia em km]--->"+JSON.stringify(distanceText,null,2));
						
						console.log("[response GOOGLE MATRIX DISTANCE DATA Distancia em metros]--->"+JSON.stringify(distanceValue,null,2));
						
						var distanceLimit = 500000;
						
						if (distanceValue > distanceLimit) {
							
							props.setAlertTitle("Ops! Verifique os endereços!");
							props.setAlertBody("A distância entre os endereços informados é maior que 500km, o que é muito distante para o tipo de serviço. Verifique os endereços e tente novamente ou escolha outro tipo de transporte para longas distâncias como ônibus e trem.");
							props.setAlert(true);						
							return;							
							
						} // end if	
						else {
							props.confirmPrompt();
						} // end else	

						return;
						
					})
					.catch(error=> {
						console.log("[alertMessage]--->"+JSON.stringify("Ocorreu um erro geral ao se comunicar com a API. Verifique sua conexão e tente novamente.",null,2));
						return;
					});
					
	} // end dispatch

};
	
export const retrieveAppFlightsInfo  = (data,props) => { 
		
	return dispatch => { 
				
				var preparedData = {
					keyword:data.keyword,
					airport:data.airport,
					flightCompany: data.flightCompany,
					flightNumber: data.flightNumber,
					flightDirection:data.flightDirection,
					flightDate:data.flightDate
				}

				var flightDateFormatted = moment(data.flightDate).toISOString();

				// set target url
				if (data.flightNumber) {
					var targetUrl = 'https://api-testing.mozio.com/v2/flights/?airline_code='+data.flightCompany+'&airport_code='+data.airport+'&flight_number='+data.flightNumber+'&flight_direction='+data.flightDirection+'&pickup_datetime='+flightDateFormatted;
				} else {
					var targetUrl = 'https://api-testing.mozio.com/v2/flights/?airline_code='+data.flightCompany+'&airport_code='+data.airport+'&flight_direction='+data.flightDirection+'&pickup_datetime='+flightDateFormatted;
				}

				// Connect to retrieve content endpoint
				axios({
					  // url    : 'https://api.mozio.com/v2/flights/?airline_code='+data.keyword+'&airport_code=GIG&flight_direction=arr&pickup_datetime=2024-02-22T11%3A00%3A00-03%3A00',
					   url: targetUrl,  
					   method : 'GET',
					   headers: {
						Accept: 'application/json',
						"API-KEY":"af496b3b08354ab49dba54dc77386225"
					}
				})				
				
				.then((response) => {

					//console.log("[response GOOGLE PLACES DATA]--->"+JSON.stringify(response,null,2));

					// Harded CODE for TERMS...
					//props.setDropdownCityItems(converterChaves(response.data));
					//props.setAddressResult(true);
					//props.setCityLoading(false);	
					
					var returnArray = []
					var predictions = response.data.flights;
					for (var i = 0; i < predictions.length; i++) {
						
						let template = predictions[i].airline.airline_name+"("+predictions[i].airline.airline_code+") "+predictions[i].flight_number+" / "+predictions[i].origin+" → "+predictions[i].destination+" / "+moment(predictions[i].datetime).format("DD MMM")+" / "+predictions[i].time

						let obj = {
							index: i,
							description: template,
							...predictions							
						}
						returnArray.push(obj);							
						
					} // end for	
					
					props.setItems(returnArray);
					return;
					
				})
				.catch(error=> {
					console.log("[alertMessage]--->"+JSON.stringify("Ocorreu um erro geral ao se comunicar com a API. Verifique sua conexão e tente novamente.",null,2));
					return;
				});
				
} // end dispatch

}

export const retrieveAppFlightAirportInfo  = (data,props) => { 
		
	return dispatch => { 
			
		var preparedData = {
			term:data.term
		}
		// Connect to retrieve content endpoint
		axios({
			   url    : config.API_URL+'/order/transfer/retrieveIATAbyName',
			   method : 'POST',
			   data   : preparedData,						   
			   headers: {
				Accept: 'application/json',
			}
		})				
		
		.then((response) => {

			console.log("[response IATA service]--->"+JSON.stringify(response.data,null,2));
			
			// Treat error and empty reesult
			// ...

			var returnArray = []
			var predictions = response.data.data;

			if (predictions.length == 0) {

				props.setAlert(true);
				props.setAlertTitle("Ops! algo deu errado!");
				props.setAlertBody("Não encontramos um aeroporto com os termos informados. Busque pela sigla de 3 caracteres do aeroporto ou pelo nome (Exemplo: GIG ou Galeao). Não utilize acentos.");
				props.setItems([]);
				return;
			} // end if

			for (var i = 0; i < predictions.length; i++) {
				
				let obj = {
					index: i,
					description: "("+predictions[i].code+") "+predictions[i].name,
					code: predictions[i].code,
					name: predictions[i].name,
					country: predictions[i].countryId,
					city: predictions[i].city,
					state: predictions[i].state,
				}
				returnArray.push(obj);							
				
			} // end for						
									
			props.setItems(returnArray);
			return;
			
		})
		.catch(error=> {
			console.log("[alertMessage]--->"+JSON.stringify("Ocorreu um erro geral ao se comunicar com a API. Verifique sua conexão e tente novamente.",null,2));
			return;
		});
				
} // end dispatch

}

export const tryRetrieveAppFlightAirportInfo  = (data,props) => { 
		
	return dispatch => { 
			
		var preparedData = {
			address:data.address
		}

		// Connect to retrieve content endpoint
		axios({
			   url    : config.API_URL+'/order/transfer/retrieveGeoCodeAddress',
			   method : 'POST',
			   data   : preparedData,						   
			   headers: {
				Accept: 'application/json',
			}
		})				
		
		.then((response) => { 

			console.log("[response retrieveAddressGeoCode]--->"+JSON.stringify(response.data.data,null,2));

					var responseData = response.data.data;

					// Can check if its an airport
					// ...

					var latitude = null;
					var longitude = null;

					if (responseData.results.length > 0) {

						// Get first result
						var location = responseData.results[0].geometry.location;
						latitude = location.lat;
						longitude = location.lng;
					
					} else {
						
						props.setLoadingRightPanel(false);
						props.setFlightAirportName(null);
						return;

					}			

					var preparedData = {
						lat:latitude,
						lng:longitude
					}

					// Connect to retrieve content endpoint
					axios({
						url: config.API_URL+'/order/transfer/retrieveIATAcode',
						method : 'POST',
						data   : preparedData,
						headers: {
						Accept: 'application/json'
					}
				})				
				
				.then((responseIATA) => {

					console.log('responseInner >>>> '+JSON.stringify(responseIATA.data.data,null,2));

					var code = responseIATA.data.data.code;
 
					if (code) {
						props.setFlightAirport(code);
						props.setFlightAirportName(code);
					} // end if
					else {
						props.setFlightAirportName(null);
					} // end else

					props.setLoadingRightPanel(false);
					return;
					
				})
				.catch(error=> {
					console.log("[alertMessage]--->"+JSON.stringify("Ocorreu um erro geral ao se comunicar com a API. Verifique sua conexão e tente novamente.",null,2));
					return;
				});
			
			
		})
		.catch(error=> {
			console.log("[alertMessage]--->"+JSON.stringify("Ocorreu um erro geral ao se comunicar com a API. Verifique sua conexão e tente novamente.",null,2));
			return;
		});

				
} // end dispatch


};

export const retrieveAndSetUserInfo  = (data,props) => { 
		
	return dispatch => {
				
		
				
} // end dispatch

};


export const retrieveCompanyDocumentInfo = (data, props) => {
	return (dispatch) => {
	  const preparedData = {
		documentType: 'cnpj',
		documentNumber: data,
		checkIntegrity: true
	  };
  
	  axios({
		url: config.API_URL + '/company/retrieveDocumentData',
		method: 'POST',
		data: preparedData,
		headers: { Accept: 'application/json' }
	  })
		.then((response) => {
		  const result = response.data;
  
		  if (!result.success || result.error) {
			if (props.setError) {
			  props.setError(result.message || 'Erro ao consultar documento.');
			}
			return;
		  }
  
		  if (props.setSuccess) {
			props.setSuccess(result);
		  }
		})
		.catch((error) => {
		  console.error('Erro ao buscar dados do CNPJ:', error);
		  if (props.setError) {
			props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
		  }
		});
	};
  };

export const retrievePersonDocumentInfo = (data, props) => {
return (dispatch) => {
	const preparedData = {
	documentType: 'cpf',
	documentNumber: data,
	checkIntegrity: false
	};

	axios({
	url: config.API_URL + '/company/retrieveDocumentData',
	method: 'POST',
	data: preparedData,
	headers: { Accept: 'application/json' }
	})
	.then((response) => {
		const result = response.data;

		if (!result.success || result.error) {
		if (props.setError) {
			props.setError(result.message || 'Erro ao consultar CPF.');
		}
		return;
		}

		if (props.setSuccess) {
		props.setSuccess(result);
		}
	})
	.catch((error) => {
		console.error('Erro ao buscar dados do CPF:', error);
		if (props.setError) {
		props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
		}
	});
};
};


export const checkCompanyPersonUserEmail = (email, { setSuccess, setError }) => {
  return (dispatch) => {
    axios({
      url: `${config.API_URL}/company/checkCompanyPersonUserEmail`,
      method: 'POST',
      data: { email },
      headers: { Accept: 'application/json' }
    })
    .then((response) => {
      if (response.data?.success && setSuccess) {
        setSuccess(response.data);
      } else if (setError) {
        setError(response.data?.message || 'Erro na verificação de e-mail.');
      }
    })
    .catch((error) => {
      if (setError) setError(error.message || 'Erro inesperado na verificação de e-mail.');
    });
  };
};

export const checkCompanyPersonUserPhone = (phone, { setSuccess, setError }) => {
  return (dispatch) => {
    axios({
      url: `${config.API_URL}/company/checkCompanyPersonUserPhone`,
      method: 'POST',
      data: { phone },
      headers: { Accept: 'application/json' }
    })
    .then((response) => {
      if (response.data?.success && setSuccess) {
        setSuccess(response.data);
      } else if (setError) {
        setError(response.data?.message || 'Erro na verificação de telefone.');
      }
    })
    .catch((error) => {
      if (setError) setError(error.message || 'Erro inesperado na verificação de telefone.');
    });
  };
};

export const retrieveNearCompaniesAlternative = (data, props) => {
    return dispatch => {
        axios({
            url: config.API_URL + '/customer/retrieveNearCompaniesAlternative',
            method: 'POST',
            data: data,
            headers: { Accept: 'application/json' }
        })
        .then(response => {
            if (response.data.success && response.data.data) {
                if (props.setSuccess) props.setSuccess(response.data.data);
            } else {
                if (props.setError) props.setError(response.data.errorMessage || 'Erro inesperado ao buscar empresas.');
            }
        })
        .catch(error => {
            console.error('Erro na busca de empresas:', error);
            if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
        });
    };
};

export const createCustomerLead = (data, props) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/customer/lead/create`,
      method: 'POST',
      data: data,
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (response.data.success) {
          if (props.setSuccess) {
            props.setSuccess(response.data);
          }
        } else {
          if (props.setError) {
            props.setError(response.data.errorMessage || 'Erro ao gerar lead.');
          }
        }
      })
      .catch((error) => {
        console.error('Erro ao gerar lead:', error);
        if (props.setError) {
          props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
        }
      });
  };
};

